export const NUMERIC_ARRAY_KEYS = ["assets", "liabilities", "equity", "items", "details"];

const toNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const getNodePrimaryValue = (node) =>
  toNumber(
    node?.summary?.sub_totals?.[0] ??
      node?.values?.[0] ??
      node?.balance ??
      node?.amount ??
      0
  );

export const extractNumericEntries = (prefix, value) => {
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    return [];
  }

  return Object.entries(value)
    .filter(([, entryValue]) => typeof entryValue === "number" && Number.isFinite(entryValue))
    .map(([key, entryValue]) => ({
      metric: prefix ? `${prefix}.${key}` : key,
      value: Number(entryValue.toFixed?.(4) ?? entryValue),
    }));
};

export const findRowByGroup = (rows = [], groupName) =>
  rows.find(
    (row) =>
      row?.group === groupName ||
      row?.id === groupName ||
      row?.label?.toUpperCase?.() === groupName
  );

export const findRowByGroupDeep = (rows = [], groupName) => {
  for (const row of rows) {
    if (
      row?.group === groupName ||
      row?.id === groupName ||
      row?.label?.toUpperCase?.() === groupName
    ) {
      return row;
    }

    if (Array.isArray(row?.children) && row.children.length > 0) {
      const foundChild = findRowByGroupDeep(row.children, groupName);
      if (foundChild) {
        return foundChild;
      }
    }
  }

  return null;
};

export const buildTopItems = (reportData) =>
  NUMERIC_ARRAY_KEYS.flatMap((key) =>
    Array.isArray(reportData?.[key])
      ? reportData[key].map((item) => ({
          bucket: key,
          name: item?.name || item?.label || item?.path || "Unknown",
          value: toNumber(item?.value ?? item?.balance ?? item?.amount ?? 0),
          percentage:
            typeof item?.percentage === "number" ? Number(item.percentage.toFixed(2)) : null,
        }))
      : []
  )
    .filter((item) => item.value !== 0)
    .sort((left, right) => Math.abs(right.value) - Math.abs(left.value))
    .slice(0, 15);

export const hasNonZeroNumbers = (value) => {
  if (typeof value === "number") {
    return value !== 0;
  }

  if (Array.isArray(value)) {
    return value.some(hasNonZeroNumbers);
  }

  if (value && typeof value === "object") {
    return Object.values(value).some(hasNonZeroNumbers);
  }

  return false;
};
